export default __webpack_public_path__ + "static/subset-UniNeueBlack-cee91e191aaa0a69d37c3d6003a9df2c.woff2";